"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAreaGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("./layout/FieldLayout");

var _FieldLabel = require("./microFields/FieldLabel");

var _FieldTextArea = require("./microFields/FieldTextArea");

var _FieldCounter = require("./microFields/FieldCounter");

var _FieldValidationMessage = require("./microFields/FieldValidationMessage");

var _fieldUtils = require("./microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * NOTE: This is not very primitive
 * it is actually quite specific to the message field
 * consider re-working this or renaming it if we ever need a textarea for anything else
 */
var TextAreaGroup = function TextAreaGroup(_ref) {
  var fieldName = _ref.fieldName,
      value = _ref.value,
      atts = _ref.atts,
      label = _ref.label,
      cashbotName = _ref.cashbotName,
      isPlastic = _ref.isPlastic,
      isInvalid = _ref.isInvalid,
      isTouched = _ref.isTouched,
      errorMessage = _ref.errorMessage,
      warningMessage = _ref.warningMessage,
      counterAriaLabel = _ref.counterAriaLabel,
      isRequiredField = _ref.isRequiredField,
      doFocus = _ref.doFocus;
  var maxLength = atts.maxLength;
  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage, true);
  var showInvalid = validationProps.isInvalid;
  var currentLength = value ? value.length : 0;
  var textareaProps = {
    name: fieldName,
    atts: atts,
    label: label,
    isRequiredField: isRequiredField,
    isInvalid: showInvalid,
    isPlastic: isPlastic,
    doFocus: doFocus
  };
  var containerProps = {
    fieldName: fieldName,
    cashbotName: cashbotName,
    cashbotOptions: {
      maxLength: maxLength
    }
  };
  var labelProps = {
    fieldName: fieldName,
    label: label,
    isInvalid: showInvalid
  };
  var counterProps = {
    id: fieldIds.counter.id,
    current: currentLength,
    maxLength: maxLength,
    isInvalid: showInvalid,
    isAssertive: true,

    /* always assertive when announcing for this field */
    announceCounter: currentLength === maxLength - 20 || currentLength === maxLength - 40 || currentLength >= maxLength - 5,
    counterAriaLabel: counterAriaLabel
  };
  var validationMsgProps = {
    id: fieldIds.validation.id,
    fieldName: fieldName,
    validationProps: validationProps,
    isAssertive: true,
    isWithCounter: true
  };
  return _react.default.createElement(_FieldLayout.FieldWrapper, containerProps, _react.default.createElement(_FieldLabel.FieldLabel, labelProps), _react.default.createElement(_FieldLayout.FieldDivWrapper, null, _react.default.createElement(_FieldTextArea.FieldTextArea, textareaProps)), _react.default.createElement("div", {
    className: "field-counter-group"
  }, _react.default.createElement(_FieldCounter.FieldCounter, counterProps), _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, validationMsgProps)));
};

exports.TextAreaGroup = TextAreaGroup;
TextAreaGroup.defaultProps = {
  value: '',
  isPlastic: false,
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null,
  isRequiredField: false,
  doFocus: false
};
TextAreaGroup.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  atts: _propTypes.default.shape({
    maxLength: _propTypes.default.number.isRequired
  }).isRequired,
  label: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  isPlastic: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  counterAriaLabel: _propTypes.default.func.isRequired,
  isRequiredField: _propTypes.default.bool,
  doFocus: _propTypes.default.bool
};